class CartClear extends HTMLElement {
  constructor() {
    super();
    this.clearButton = this.querySelector("a.cart-drawer__clear-button");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
  }

  connectedCallback() {
    this.clearButton.addEventListener("click", this.clearCart.bind(this));
  }

  disconnectedCallback() {
    this.clearButton.removeEventListener("click", this.clearCart.bind(this));
  }

  clearCart() {
    const sections = this.cart
      .getSectionsToRender()
      .map((section) => section.section);
    const sectionUrl = window.location.pathname;

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sections: sections,
        sections_url: sectionUrl,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-drawer",
          cartData: data,
        });
        updateFreeShipping();
      });
  }
}

// Define the custom element
customElements.define("cart-clear", CartClear);
